<template>
  <div class="container-groups">
    <NavBar/>
    <div class="stage-selector">
      <select v-model="selectedStageId" @change="loadGroups">
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.name }}
        </option>
      </select>
    </div>
    <GroupsDisplay
        :groups="groups"
        :groupPlayersMap="groupPlayersMap"
    />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import GroupsDisplay from '@/components/GroupsDisplay.vue';
import stageService from "@/services/stageService";
import groupService from "@/services/groupService";

export default {
  name: 'Grupos',
  components: {
    NavBar,
    GroupsDisplay,
  },
  data() {
    return {
      stages: [],
      selectedStageId: '',
      selectedStage: null,
      groups: [],
      groupPlayersMap: [],
    }
  },
  async created() {
    await this.loadStages();
  },
  methods: {
    async loadStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data.map(stage => ({
          ...stage
        }));
        if (this.stages.length > 0) {
          this.selectedStageId = this.stages[this.stages.length - 1].id;
          this.selectedStage = this.stages[this.stages.length - 1];
          await this.loadGroups();
        }
      } catch (error) {
        console.error('Erro ao buscar etapas:', error);
      }
    },
    async loadGroups() {
      if (!this.selectedStageId) return [];

      try {
        const response = await groupService.getGroupsByStage(this.selectedStageId);
        this.groups = response.data || [];

        if (this.groups.length === 0) {
          this.groupPlayersMap = {};
          return;
        }

        const lastStage = this.stages[this.stages.length - 1];
        const isLastStage = lastStage && lastStage.id === this.selectedStageId;

        const playersPromises = this.groups.map(group => {
          if (isLastStage) {
            return groupService.getPlayersByGroup(group.id);
          } else {
            return groupService.getPlayerHistoryByStage(this.selectedStageId, group.id);
          }
        });

        const playersResponses = await Promise.all(playersPromises);

        this.groupPlayersMap = this.groups.reduce((acc, group, index) => {
          acc[group.id] = playersResponses[index]?.data || [];
          return acc;
        }, {});

      } catch (error) {
        console.error('Erro ao buscar grupos:', error);
      }
    },
  }
};
</script>

<style scoped>
.container-groups{
  background-color: #003366;
  width: 100%;
  min-height: 100vh;
  height: 100%;
}
.stage-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
  text-align: center;
  margin: 2rem 0;
  justify-content: center;
}

.stage-selector select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.stage-selector span {
  font-size: 1rem;
  color: white;
}

</style>
  